// #region Pico stuff
var Pico = Pico || Object.create(null);
// #endregion

// #region Handlebars
var HandlebarsUtils = (function (handlebars) {
    handlebars.registerHelper('PerfionImageSrc', function (guid, width, height) {
        var src;

        // placeholder image when missing
        if (guid === "00000000-0000-0000-0000-000000000000") {
            src = "/Admin/Public/GetImage.ashx?width=" + width + "&amp;height=" + height + "&amp;crop=5&amp;Compression=75&amp;DoNotUpscale=true&amp;FillCanvas=true&amp;image=/Files/Images/missing_image.jpg";
        } else {
            src = GlobalSettings.PerfionApiUrl + "/Perfion/Image.aspx?id=" + guid + "&size=" + width + "x" + height + "&format=png";
        }

        return new Handlebars.SafeString(src);
    });

    handlebars.registerHelper('hasVideos', function (inGallery, youtubeLinks, vimeoLinks, options) {
        var hasVideos = function (videoLinks, videoType) {
            return videoLinks.some(function (feature) { return feature.view === videoType; });
        };
        var specsVideo = "WebVariant";
        var galleryVideo = "WebList";

        if (inGallery) {
            return hasVideos(youtubeLinks, galleryVideo) || hasVideos(vimeoLinks, galleryVideo) ? options.fn(this) : options.inverse(this);
        }

        return hasVideos(youtubeLinks, specsVideo) || hasVideos(vimeoLinks, specsVideo) ? options.fn(this) : options.inverse(this);
    });

    handlebars.registerHelper('facebookPixelSearch',
        function (name, productNumber, price, currency, searchString) {
            if (Cookiebot.consent.marketing) {
                if (!fbq) { return; }

                fbq('track', 'Search', {
                    content_name: name,
                    content_category: 'Products',
                    content_ids: [productNumber],
                    value: price,
                    currency: currency,
                    search_string: searchString
                });
            }
        });

    var handlebarsUtils = Object.create(null);

    function renderTemplate(templateId, containerId, data, fireEvents) {
        var container = document.getElementById(containerId);
        var scriptTemplate = document.getElementById(templateId);
        var eventData = { 'detail': { 'containerId': containerId, "templateId": templateId, "data": data } };

        if (fireEvents) {
            container.dispatchEvent(new CustomEvent('templateRendering', eventData));
        }

        if (container && scriptTemplate) {
            var template = Handlebars.compile(scriptTemplate.innerHTML);
            var compiledHtml = template(data);
            container.innerHTML = compiledHtml;
        }

        if (fireEvents) {
            container.dispatchEvent(new CustomEvent('templateRendered', eventData));
        }
    };

    Object.defineProperties(handlebarsUtils, {
        renderTemplate: {
            value: renderTemplate
        }
    });

    return handlebarsUtils;
})(Handlebars);
// #endregion

// #region Custom DW objects
var CustomRequest = (function () {
    function CustomRequest() { }

    CustomRequest.prototype.newRequest = function (url, method, data, successCallback, errorCallback, returnJson, headers) {
        if (returnJson == null) {
            returnJson = true;
        }

        var xhr = new XMLHttpRequest();
        xhr.open(method, url, true);
        xhr.onreadystatechange = function () {
            function error(message) {
                console.warn(message);

                if (typeof errorCallback == "function") {
                    errorCallback(this.response);
                }
            }

            if (this.readyState == XMLHttpRequest.DONE && this.status == 200) {
                var data;

                if (this.responseType === 'json') {
                    data = this.response.message.trim();
                } else {
                    data = this.response.trim();
                }

                if (returnJson) {
                    if (data == "") {
                        console.warn(url + ": Response is empty");
                        data = {};
                    } else if (data.indexOf("<") == 0) {
                        error(url + ": URL returned HTML instead of JSON");
                        return;
                    } else {
                        try {
                            data = JSON.parse(data);
                        } catch (e) {
                            error(url + ": Could not parse the JSON data");
                            return;
                        }
                    }
                }

                if (typeof successCallback == "function") {
                    successCallback(data);
                }
            } else if (this.readyState == XMLHttpRequest.DONE && this.status != 200) {
                error(url + ": XMLHttpRequest failed");
            }
        };

        xhr.setRequestHeader('cache-control', 'no-cache, must-revalidate, post-check=0, pre-check=0');
        xhr.setRequestHeader('cache-control', 'max-age=0');
        xhr.setRequestHeader('expires', '0');
        xhr.setRequestHeader('expires', 'Tue, 01 Jan 1980 1:00:00 GMT');
        xhr.setRequestHeader('pragma', 'no-cache');

        var isFormContent = false;
        if (headers && typeof headers === "object") {
            var names = Object.getOwnPropertyNames(headers);

            for (var prop in Object.getOwnPropertyNames(headers)) {
                var propName = names[prop];
                var propValue = headers[propName];

                if (propName === "Content-Type" && propValue == "application/x-www-form-urlencoded") {
                    isFormContent = true;
                }

                xhr.setRequestHeader(propName, propValue);
            }
        }

        if (data) {
            if (isFormContent) {
                xhr.send(data);
            } else {
                xhr.send(JSON.stringify(data));
            }
        } else {
            xhr.send();
        }
    };

    CustomRequest.prototype.Fetch = function () {
        var self = this;

        return {
            get: function (url, successCallback, errorCallback, returnJson, headers) {
                self.newRequest(url, "GET", null, successCallback, errorCallback, returnJson, headers);
            },

            post: function (url, data, successCallback, errorCallback, returnJson, headers) {
                self.newRequest(url, "POST", data, successCallback, errorCallback, returnJson, headers);
            }
        };
    };

    return new CustomRequest();
})();
var CustomCart = (function (request) {
    function CustomCart() { }

    CustomCart.prototype.UpdateCart = function (containerId, url, command, preloader) {
        if (!containerId) {
            console.log("Cart: The container does not exist");
            return;
        }

        if (preloader == true) {
            var overlayElement = document.createElement('div');
            overlayElement.className = "preloader-overlay";
            overlayElement.setAttribute('id', "CartOverlay");
            var overlayElementIcon = document.createElement('div');
            overlayElementIcon.className = "preloader-overlay__icon dw-mod";
            overlayElementIcon.style.top = window.pageYOffset + "px";
            overlayElement.appendChild(overlayElementIcon);

            document.getElementById('content').parentNode.insertBefore(overlayElement, document.getElementById('content'));
        }

        var miniCartButtons = document.getElementsByClassName("js-mini-cart-button");
        for (var i = 0; i < miniCartButtons.length; i++) {
            var cartButton = document.getElementsByClassName("js-mini-cart-button")[i];
            cartButton.classList.add("mini-cart-update");
        }

        //var queryParams = new QueryArray(url);
        //queryParams.combineWithParams(command);
        //queryParams.setValue("feedtype", "Counter");

        url += "&feedtype=Counter";
        request.Fetch().post(url, command, updateSuccess, updateFailed, true, { 'Content-Type': 'application/x-www-form-urlencoded' });

        function updateSuccess(data) {
            if (preloader == true) {
                var overlayNode = document.getElementById('CartOverlay');
                overlayNode.parentNode.removeChild(overlayNode);
            }

            if (document.getElementById(containerId) && containerId != "miniCart") {
                HandlebarsBolt.UpdateContent(containerId, url);
            }

            var miniCartCounters = document.getElementsByClassName("js-mini-cart-counter");

            for (var i = 0; i < miniCartCounters.length; i++) {
                var cartCounter = miniCartCounters[i];

                if (cartCounter) {
                    cartCounter.innerHTML = "";

                    var miniCartButtons = document.getElementsByClassName("js-mini-cart-button");
                    for (var i = 0; i < miniCartButtons.length; i++) {
                        var cartButton = document.getElementsByClassName("js-mini-cart-button")[i];
                        cartButton.classList.remove("mini-cart-update");
                    }

                    HandlebarsBolt.CreateItemsFromJson(data, cartCounter.getAttribute("id"));
                }
            }

            var event = new CustomEvent('cartUpdated', { 'detail': { "command": command, "containerId": containerId, "url": url, "preloader": preloader, "data": data } });
            document.dispatchEvent(event);
        }

        function updateFailed(data) {
            location.reload();

            var event = new CustomEvent('cartUpdated', { 'detail': { "command": command, "containerId": containerId, "url": url, "preloader": preloader, "data": data } });
            document.dispatchEvent(event);
        }
    }

    return new CustomCart();
})(CustomRequest);
// #endregion

// #region Polyfills
(function () {
    // Production steps of ECMA-262, Edition 5, 15.4.4.19
    // Reference: http://es5.github.io/#x15.4.4.19
    if (!Array.prototype.map) {
        Array.prototype.map = function (callback/*, thisArg*/) {
            var T, A, k;

            if (this == null) {
                throw new TypeError('this is null or not defined');
            }

            // 1. Let O be the result of calling ToObject passing the |this| 
            //    value as the argument.
            var O = Object(this);

            // 2. Let lenValue be the result of calling the Get internal 
            //    method of O with the argument "length".
            // 3. Let len be ToUint32(lenValue).
            var len = O.length >>> 0;

            // 4. If IsCallable(callback) is false, throw a TypeError exception.
            // See: http://es5.github.com/#x9.11
            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
            if (arguments.length > 1) {
                T = arguments[1];
            }

            // 6. Let A be a new array created as if by the expression new Array(len) 
            //    where Array is the standard built-in constructor with that name and 
            //    len is the value of len.
            A = new Array(len);

            // 7. Let k be 0
            k = 0;

            // 8. Repeat, while k < len
            while (k < len) {

                var kValue, mappedValue;

                // a. Let Pk be ToString(k).
                //   This is implicit for LHS operands of the in operator
                // b. Let kPresent be the result of calling the HasProperty internal 
                //    method of O with argument Pk.
                //   This step can be combined with c
                // c. If kPresent is true, then
                if (k in O) {

                    // i. Let kValue be the result of calling the Get internal 
                    //    method of O with argument Pk.
                    kValue = O[k];

                    // ii. Let mappedValue be the result of calling the Call internal 
                    //     method of callback with T as the this value and argument 
                    //     list containing kValue, k, and O.
                    mappedValue = callback.call(T, kValue, k, O);

                    // iii. Call the DefineOwnProperty internal method of A with arguments
                    // Pk, Property Descriptor
                    // { Value: mappedValue,
                    //   Writable: true,
                    //   Enumerable: true,
                    //   Configurable: true },
                    // and false.

                    // In browsers that support Object.defineProperty, use the following:
                    // Object.defineProperty(A, k, {
                    //   value: mappedValue,
                    //   writable: true,
                    //   enumerable: true,
                    //   configurable: true
                    // });

                    // For best browser support, use the following:
                    A[k] = mappedValue;
                }
                // d. Increase k by 1.
                k++;
            }

            // 9. return A
            return A;
        };
    }

    if (!Array.prototype.some) {
        Array.prototype.some = function (fun, thisArg) {
            'use strict';

            if (this == null) {
                throw new TypeError('Array.prototype.some called on null or undefined');
            }

            if (typeof fun !== 'function') {
                throw new TypeError();
            }

            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(thisArg, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    if (!Array.prototype.every) {
        Array.prototype.every = function (callbackfn, thisArg) {
            'use strict';
            var T, k;

            if (this == null) {
                throw new TypeError('this is null or not defined');
            }

            // 1. Let O be the result of calling ToObject passing the this 
            //    value as the argument.
            var O = Object(this);

            // 2. Let lenValue be the result of calling the Get internal method
            //    of O with the argument "length".
            // 3. Let len be ToUint32(lenValue).
            var len = O.length >>> 0;

            // 4. If IsCallable(callbackfn) is false, throw a TypeError exception.
            if (typeof callbackfn !== 'function' && Object.prototype.toString.call(callbackfn) !== '[object Function]') {
                throw new TypeError();
            }

            // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
            if (arguments.length > 1) {
                T = thisArg;
            }

            // 6. Let k be 0.
            k = 0;

            // 7. Repeat, while k < len
            while (k < len) {

                var kValue;

                // a. Let Pk be ToString(k).
                //   This is implicit for LHS operands of the in operator
                // b. Let kPresent be the result of calling the HasProperty internal 
                //    method of O with argument Pk.
                //   This step can be combined with c
                // c. If kPresent is true, then
                if (k in O) {
                    var testResult;
                    // i. Let kValue be the result of calling the Get internal method
                    //    of O with argument Pk.
                    kValue = O[k];

                    // ii. Let testResult be the result of calling the Call internal method 
                    // of callbackfn with T as the this value if T is not undefined 
                    // else is the result of calling callbackfn 
                    // and argument list containing kValue, k, and O.
                    if (T) testResult = callbackfn.call(T, kValue, k, O);
                    else testResult = callbackfn(kValue, k, O)

                    // iii. If ToBoolean(testResult) is false, return false.
                    if (!testResult) {
                        return false;
                    }
                }
                k++;
            }
            return true;
        };
    }
})();
// #endregion

// #region Language Picker urls
(function () {
    if (typeof languageUrlFeed === "undefined") {
        return;
    }

    document.querySelector("#pp__language-preloader").classList.add('u-hidden');
    CustomRequest.Fetch().get(languageUrlFeed, function (languages) {
        for (var index in languages) {
            var languageLink = document.querySelector("#lang-" + languages[index].AreaId);
            languageLink.href = languages[index].Link;
        }

        document.querySelector("#pp__language-container").classList.remove('u-hidden');
    }, function () {
        console.warn("Could not get language urls");
    }, true, {
        "X-NavTag": navTag,
        "X-AreaIDs": areaIds,
        "X-GroupID": groupId,
        "X-ProductID": productId,
        "X-VariantID": productVariantId
    });
})();
// #endregion

//Calculate min-height of content - footer margin-top
window.onload = function () {
    function getBrowserDimensions() {
        return {
            height:
                window.innerHeight ||
                document.documentElement.clientHeight ||
                document.body.clientHeight
        };
    }

    var browser_dims = getBrowserDimensions();

    var height = browser_dims.height;
    var sitecontent = document.getElementById("sitecontent").offsetHeight;
    var a = height - sitecontent;

    if (a > 0) {
        var x = document.getElementById("footer").style.marginTop = a + "px";
    }
};

// #region Video Gallery
(function (window, pico) {
    var carousels = [];

    function loadYoutube(links) {
        return links.filter(function (link) {
            return link.view === "WebList";
        }).map(function (videoFeature) {
            return {
                link: "https://www.youtube.com/embed/" + videoFeature.text + "?rel=0",
                smallImage: "https://img.youtube.com/vi/" + videoFeature.text + "/default.jpg",
                largeImage: "https://img.youtube.com/vi/" + videoFeature.text + "/maxresdefault.jpg"
            };
        });
    }

    function loadVimeo(links, vimeoImages) {
        return links.filter(function (link) {
            return link.view === "WebList";
        }).map(function (videoFeature) {
            return {
                link: "https://player.vimeo.com/video/" + videoFeature.text + "?byline=0&portrait=0",
                smallImage: vimeoImages[videoFeature.text].smallImage,
                largeImage: vimeoImages[videoFeature.text].largeImage
            };
        });
    }

    function pushArray(array, elements) {
        for (var index in elements) {
            array.push(elements[index]);
        }
    };

    function loadVideos(data, callback) {
        var videos = [];

        // fetch vimeo images (call webservice)
        if (data.vimeoLinks && data.vimeoLinks.length > 0) {
            var videoEvent = new EventTarget();
            var reqCount = data.vimeoLinks.length;
            var videoImages = {};

            videoEvent.addEventListener("ResolvedAll", function (event) {
                pushArray(videos, loadYoutube(data.youtubeLinks));
                pushArray(videos, loadVimeo(data.vimeoLinks, event.detail));
                callback(videos);
            });

            for (var i in data.vimeoLinks) {
                CustomRequest.newRequest("https://vimeo.com/api/v2/video/" + data.vimeoLinks[i].text + ".json", "GET", null, function (data) {
                    var obj = Object.create(null);
                    Object.defineProperties(obj, {
                        smallImage: { value: data[0].thumbnail_small },
                        largeImage: { value: data[0].thumbnail_large }
                    });
                    videoImages[data[0].id] = obj;

                    // all requests have been resolved
                    if (--reqCount === 0) {
                        videoEvent.dispatchEvent(new CustomEvent("ResolvedAll", { detail: videoImages }));
                    }
                }, function (message) {
                    console.warn(message);
                });
            }
        } else if (data.youtubeLinks) {
            pushArray(videos, loadYoutube(data.youtubeLinks));
            callback(videos);
        }
    }

    window.addEventListener('DOMContentLoaded', function () {
        // custom video
        var tabsContainer = document.getElementById('Tabs');
        var galleryImagesContainer = document.getElementById("GalleryImagesContainer");
        var galleryModal = document.getElementById("GalleryModal");


        document.querySelectorAll(".js-remove-after-load").forEach(function (el) {
            el.remove();
        });

        // tab section
        if (tabsContainer) {
            tabsContainer.addEventListener("contentLoaded", function (event) {
                var detail = event.detail;
                var videos = [];

                if (detail.data) {
                    if (detail.data.youtubeLinks) {
                        pushArray(videos,
                            detail.data.youtubeLinks.filter(function (link) {
                                return link.view === "WebVariant";
                            }).map(function (videoFeature) {
                                return {
                                    link: "https://www.youtube.com/embed/" + videoFeature.text + "?rel=0"
                                };
                            }));
                    }

                    if (detail.data.vimeoLinks) {
                        pushArray(videos,
                            detail.data.vimeoLinks.filter(function (link) {
                                return link.view === "WebVariant";
                            }).map(function (videoFeature) {
                                return {
                                    link: "https://player.vimeo.com/video/" + videoFeature.text + "?byline=0&portrait=0"
                                };
                            }));
                    }

                    detail.data.videos = videos;

                    // compile local handlebar templates and insert in DOM
                    HandlebarsUtils.renderTemplate("SpecsTemplate", "Tabs", detail.data);

                    // render any handlebars templates under tabs (initialize logic from DW)
                    var ajaxContainer = document.querySelectorAll("#Tabs .js-handlebars-root");

                    for (var i = 0; i < ajaxContainer.length; i++) {
                        var ajaxContainerElement = ajaxContainer[i];

                        if (!ajaxContainerElement.getAttribute('data-json-feed')) {
                            console.log("Ajax element: Please specify json feed via data attribute: data-json-feed");
                        }

                        if (!ajaxContainerElement.hasAttribute('data-init-onload') || !ajaxContainerElement.getAttribute('data-init-onload')) {
                            HandlebarsBolt.UpdateContent(ajaxContainerElement.id, ajaxContainerElement.getAttribute('data-json-feed'), false, ajaxContainerElement.getAttribute('data-template'), ajaxContainerElement.getAttribute('data-preloader'));
                        }
                    }
                }
            });
        }


        if (galleryModal) {
            galleryModal.addEventListener("templateRendered", function (event) {
                Gallery.Init();

                // initialize all carousels
                for (var index in carousels) {
                    var carousel = carousels[index];

                    if (carousel.id == "modalCarousel") {

                        window[carousel.id] = new CarouselModule('#' + carousel.id,
                            {
                                slidesInView: carousel.slidesInView,
                                direction: carousel.direction,
                                preloaderSize: carousel.preloaderSize,
                                showCounter: carousel.isModal
                            });

                        window[carousel.id].Init();
                        document.querySelectorAll(".js-remove-after-load").forEach(function (el) {
                            el.remove();
                        });
                    }
                }
            });
        }

        // gallery section
        if (galleryImagesContainer) {
            galleryImagesContainer.addEventListener("templateRendered", function (event) {
                var data = event.detail.data;
                var imageCount = 0;

                Gallery.Init();

                // initialize all carousels
                for (var index in carousels) {
                    var carousel = carousels[index];
                    if (carousel.id == "productCarousel") {

                        window[carousel.id] = new CarouselModule('#' + carousel.id,
                            {
                                slidesInView: carousel.slidesInView,
                                direction: carousel.direction,
                                preloaderSize: carousel.preloaderSize,
                                showCounter: carousel.isModal
                            });
                        window[carousel.id].Init();
                        document.querySelectorAll(".js-remove-after-load").forEach(function (el) {
                            el.remove();
                        });
                    }

                }
            });

            galleryImagesContainer.addEventListener("contentLoaded", function (event) {
                var data = event.detail.data;
                var imageCount = 0;

                if (data) {
                    loadVideos(data,
                        function (videos) {
                            var payload = {
                                images: data.images,
                                videos: videos
                            };

                            for (var index in carousels) {
                                var carousel = carousels[index];




                                if (carousel.id == "productCarousel" && !document.getElementById(carousel.id).classList.contains('carousel--vertical')) {

                                    window[carousel.id] = new CarouselModule('#' + carousel.id,
                                        {
                                            slidesInView: carousel.slidesInView,
                                            direction: carousel.direction,
                                            preloaderSize: carousel.preloaderSize,
                                            showCounter: carousel.isModal
                                        });
                                    window[carousel.id].Init();
                                }

                            }

                            HandlebarsUtils.renderTemplate("GalleryModalTemplate", "GalleryModal", payload, true);
                        });
                }
            });
        }
    });

    function initDWCarousel(id, slidesInView, direction, preloaderSize, isModal) {
        carousels.push({ id: id, slidesInView: slidesInView, direction: direction, preloaderSize: preloaderSize, isModal: isModal });
    }

    Object.defineProperty(pico, "initDWCarousel", { writable: false, configurable: false, value: initDWCarousel });
})(window, Pico);
// #endregion

// #region FAQ Module checkbox switching
(function (document) {

    var inputs = document.querySelectorAll('.pp__accordion-question > input');

    inputs.forEach(function (el) {
        el.addEventListener('click', function (e) {
            var inputElement = e.target;

            if (inputElement.type === "checkbox") {
                var inputChecked = inputElement.checked;

                for (var index in inputs) {
                    var input = inputs[index];
                    input.checked = false;
                }

                inputElement.checked = inputChecked;
            }
        });
    });
})(document);
// #endregion


window.toggleProductFeature = function accordionToggle(event) {

    event.target.classList.toggle("active");
    var accordionContent = event.target.nextSibling.nextSibling;

    if (accordionContent.style.maxHeight) {
        accordionContent.style.maxHeight = null;
    } else {
        accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
    }
}

// #region options accordion
//(function (document) {
//    RapidoHook.contentLoaded(function (e) {
//        console.log(e);
//        var accordionHeader = document.getElementById(e.detail.containerId).querySelectorAll(".product-feature__header");

//            function accordionToggle(e) {
//                e.preventDefault();
//                this.classList.toggle("active");
//                var accordionContent = this.nextSibling.nextSibling;

//                if (accordionContent.style.maxHeight) {
//                    accordionContent.style.maxHeight = null;
//                } else {
//                    accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
//                }
//            }

//            for (var i = 0; i < accordionHeader.length; i++) {
//                accordionHeader[i].addEventListener("click", accordionToggle);
//            }
//    });

//})(document);
// #endregion

